<i18n src="./resources/locales.json"></i18n>

<template>
  <v-dialog v-model="dialog" width="400" max-width="60%" @click:outside="close">
    <v-card class="surface">
      <v-card-title v-once primary-title>
        {{ $t('dialog.title') }}
      </v-card-title>

      <v-card-text>
        <v-form>
          <v-row>
            <v-col>
              <v-select
                v-model="selectedOptions.sorting"
                :items="availableSortOptions"
                :label="$t('dialog.labels.sort')"
              ></v-select>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn plain @click="close">
          <span v-once>{{ $t('dialog.options.cancel') }}</span>
        </v-btn>
        <v-btn color="primary" @click="handleUpdate">
          <span v-once>{{ $t('dialog.options.update') }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { STATS_SORTING } from '@/constants/businessProcess/constants';

export default {
  name: 'EcsSupervisorDashboardOptionsDialog',

  data() {
    return {
      selectedOptions: {
        sorting: STATS_SORTING.Health
      },
      availableSortOptions: [
        {
          value: STATS_SORTING.Health,
          text: this.$t('dialog.sortingOptions.health')
        },
        {
          value: STATS_SORTING.Custom,
          text: this.$t('dialog.sortingOptions.custom')
        }
      ],
      dialog: false
    };
  },

  computed: {
    ...mapGetters('SETTINGS', ['supervisorDashboardSettings'])
  },

  methods: {
    open() {
      this.dialog = true;
      this.selectedOptions.sorting = this.supervisorDashboardSettings.adaptiveDashboards.sorting;
    },

    close() {
      this.dialog = false;
    },

    handleUpdate() {
      this.$emit('update-dashboard', this.selectedOptions);
      this.close();
    }
  }
};
</script>
